import ProfileImage from './ProfileImage.js';
import { helpers } from '../services/helpers';
import { Globe, Lock, Check } from 'lucide-react';
import './ReviewDetail.css';
import './UserList.css';
import { useState } from 'react';

function PainDiaryProfile({ diary, canEdit }) {
    const [copied, setCopied] = useState(false);

    const handleCopyLink = () => {
        const link = `${window.location.origin}/diary/${diary.patient.id}`;
        navigator.clipboard.writeText(link).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="review-card allow-overflow-hidden pain-diary-header" style={{
            marginBottom: '1rem',
            display: 'flex',
            alignItems: 'flex-center',
            justifyContent: 'space-between',
            padding: '10px'
        }}>
            <div style={{ display: "flex", alignItems: "flex-center", flex: "1", minWidth: "0" }}>
                <ProfileImage profile={diary.patient} size={80} />
                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0.5rem', flex: '1', minWidth: '0' }}>
                    <span className="profile-hover-name" style={{ whiteSpace: 'nowrap' }}>{diary.patient.username}</span>

                    <div style={{ textAlign: 'left' }}>
                        Member since <span style={{ fontWeight: 'bold' }}>{helpers.englishDate(diary.patient.createdAt)}</span>
                    </div>
                    <div style={{ fontWeight: 'bold', textAlign: 'left' }}>
                        {diary.patient.surgeryCount} {diary.patient.surgeryCount == 1 ? 'Surgery' : 'Surgeries'}
                    </div>
                </div>
            </div>
            {canEdit ? (
                diary.public ? (
                    <div style={{ display: 'flex' }} className="hide-large">
                        <span className="tooltip-container" style={{ display: 'flex', alignItems: 'center' }}>
                            <Globe style={{ color: '#606366' }} />
                            <div style={{ marginLeft: "0.25rem", marginRight: "0.25rem", fontWeight: "bold" }}>Public</div>
                            <span className="tooltip-text">Anyone can view this page.</span>
                        </span>
                        <div
                            onClick={handleCopyLink}
                            style={{ color: copied ? '#27AE60' : '#2880B9', fontWeight: "bold", cursor: "pointer", display: 'flex', alignItems: 'center', gap: '4px' }}
                        >
                            {copied ? <Check size={14} /> : null}
                            {copied ? 'Copied!' : 'Copy Shareable Link'}
                        </div>
                    </div>
                ) : (
                    <span className="tooltip-container hide-large" style={{ display: 'flex', alignSelf: 'flex-start' }}>
                        <Lock style={{ color: '#606366' }} />
                        <div style={{ marginLeft: "0.5rem", fontWeight: "bold" }}>Private</div>
                        <span className="tooltip-text">Only you can see this page.</span>
                    </span>
                )
            ) : (
                <></>
            )}
            {canEdit ? (
                diary.public ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }} className="hide-small">
                        <span className="tooltip-container" style={{ display: 'flex', alignItems: 'center' }}>
                            <Globe style={{ color: '#606366' }} />
                            <div style={{ marginLeft: "0.5rem", fontWeight: "bold" }}>Public</div>
                            <span className="tooltip-text diary-tooltip-text" style={{ left: "-20px" }}>Anyone can view this page.</span>
                        </span>
                        <div
                            onClick={handleCopyLink}
                            style={{ color: copied ? '#27AE60' : '#2880B9', marginLeft: "0.5rem", fontWeight: "bold", cursor: "pointer", display: 'flex', alignItems: 'center', gap: '4px', textAlign: 'right' }}
                        >
                            {copied ? <Check size={14} /> : null}
                            {copied ? 'Copied!' : 'Copy Shareable Link'}
                        </div>
                    </div>
                ) : (
                    <span className="tooltip-container hide-small" style={{ display: 'flex', alignSelf: 'flex-start' }}>
                        <Lock style={{ color: '#606366' }} />
                        <div style={{ marginLeft: "0.5rem", fontWeight: "bold" }}>Private</div>
                        <span className="tooltip-text diary-tooltip-text" style={{ left: "-20px" }}>Only you can see this page.</span>
                    </span>
                )
            ) : (
                <></>
            )}
        </div>
    );
}

export default PainDiaryProfile;